import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";

const MESSAGES = {
  loading: { icon: Loader2, title: "جارٍ التحقق من الدفع...", sub: "لحظات ويُفعَّل اشتراكك تلقائياً", cls: "text-emerald-900", spin: true },
  paid: { icon: CheckCircle2, title: "تم الدفع وتفعيل اشتراكك بنجاح", sub: "جارٍ تحويلك إلى لوحة التحكم...", cls: "text-emerald-700" },
  verify: { icon: CheckCircle2, title: "تم استلام دفعتك بنجاح", sub: "بقيت خطوة أخيرة: أدخل رمز التحقق المرسل إلى بريدك الإلكتروني لإكمال تفعيل اشتراكك — جارٍ تحويلك...", cls: "text-emerald-700" },
  unpaid: { icon: XCircle, title: "لم يكتمل الدفع", sub: "لم يتم الخصم أو لم تُستكمل العملية — يمكنك المحاولة مرة أخرى من صفحة الاشتراك.", cls: "text-amber-600" },
  error: { icon: XCircle, title: "تعذر التحقق من الدفع", sub: "إذا تم الخصم من بطاقتك فسيتم تفعيل اشتراكك تلقائياً، أو تواصل مع الدعم.", cls: "text-rose-600" },
};

export default function PaymentResult() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const id = params.get("id");
    if (!id) { setState("error"); return; }
    api.post(`/payments/moyasar/verify/${encodeURIComponent(id)}`)
      .then((r) => {
        if (r.data.active) {
          setState("paid");
          setTimeout(() => window.location.assign("/dashboard?renewed=1"), 1500);
        } else if (r.data.needs_email_verification) {
          setState("verify");
          setTimeout(() => window.location.assign("/dashboard"), 2500);
        } else setState("unpaid");
      })
      .catch(() => setState("error"));
  }, [params]);

  const m = MESSAGES[state];
  const Icon = m.icon;
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="payment-result-page">
      <div className="w-full max-w-md bg-white rounded-2xl border p-8 shadow-sm text-center space-y-4">
        <Icon className={`w-12 h-12 mx-auto ${m.cls} ${m.spin ? "animate-spin" : ""}`} />
        <h1 className="text-lg font-extrabold text-emerald-950" data-testid="payment-result-title">{m.title}</h1>
        <p className="text-sm text-slate-500 leading-7">{m.sub}</p>
        {state !== "loading" && state !== "paid" && (
          <Link to="/dashboard" data-testid="payment-result-back"
            className="inline-block text-sm font-bold text-emerald-800 hover:text-emerald-950">
            العودة إلى لوحة التحكم
          </Link>
        )}
      </div>
    </div>
  );
}
